module.exports = __webpack_public_path__ + "static/media/volunteer.f0e495a8.png";